var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.31,
    height: 36.089,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.154 0a18.156 18.156 0 0 0-2.836 36.089V23.403h-4.61v-5.249h4.61v-4c0-4.549 2.711-7.063 6.857-7.063a28 28 0 0 1 4.064.354v4.467h-2.288a2.624 2.624 0 0 0-2.959 2.836v3.4h5.035l-.8 5.249h-4.23v12.686A18.156 18.156 0 0 0 18.16-.006Z",
    "data-name": "Path 558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhite);
export default __webpack_public_path__ + "static/media/facebookWhite.bfe9f78e59ff44470b684df536063658.svg";
export { ForwardRef as ReactComponent };